<template>
  <div class="h-full bg-white rounded flex flex-col">
    <UtilPlaceholder class="h-64 rounded" />

    <div class="px-2 pb-2 relative">
      <div class="avatar flex items-center">
        <UtilPlaceholder class="h-32 w-32 rounded-full border-4 border-white" />

        <div class="flex-auto ml-2">
          <UtilPlaceholder class="h-3 w-6/12 mt-8" />
          <UtilPlaceholder class="h-3 w-8/12 mt-1" />
        </div>
      </div>

      <UtilPlaceholder class="h-5 mt-20" />
      <UtilPlaceholder class="h-5 w-5/12 mt-1" />

      <UtilPlaceholder class="h-3 w-8/12 mt-2" />
      <UtilPlaceholder class="h-3 w-4/12 mt-1" />

      <UtilPlaceholder class="h-3 w-3/12 mt-2" />
    </div>
  </div>
</template>

<script>
import UtilPlaceholder from '@/components/utils/placeholders/UtilPlaceholder'

export default {
  name: 'UtilPlaceholderHitCard',
  components: {
    UtilPlaceholder
  }
}
</script>

<style lang="scss" scoped>
.avatar {
  position: absolute;
  top: -30px;
  left: 8px;
  right: 0;
}
</style>
